import type { ChangeEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TextInput } from '@cbhq/cds-web/controls';
import { VStack } from '@cbhq/cds-web/layout';
import { SectionHeader } from '@cbhq/cds-web/section-header/SectionHeader';
import { Text } from '@cbhq/cds-web/typography/Text';

const messages = defineMessages({
  emailLabel: {
    id: 'Team.inviteTray.emailLabel',
    defaultMessage: 'Email',
    description: 'Invite tray email label',
  },
  emailPlaceholder: {
    id: 'Team.inviteTray.emailPlaceholder',
    defaultMessage: 'name@company.com',
    description: 'Invite tray email placeholder',
  },
  emailHelperText: {
    id: 'Team.inviteTray.emailHelperText',
    defaultMessage: 'Enter their work email',
    description: 'Invite tray email helper text',
  },
  emailErrorIconHelperText: {
    id: 'Team.inviteTray.emailErrorIconHelperText',
    defaultMessage: 'Email error icon helper text',
    description: 'Accessibility label for the invite tray email error icon',
  },
});

export type InviteEmailSectionParams = {
  email: string;
  onEmailChange: (event: ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string | null;
};

export function InviteEmailSection({
  email,
  onEmailChange,
  errorMessage,
}: InviteEmailSectionParams) {
  const { formatMessage } = useIntl();
  const hasError = errorMessage != null && errorMessage.length > 0;

  return (
    <VStack width="100%" gap={1}>
      <SectionHeader
        title={<Text font="headline">{formatMessage(messages.emailLabel)}</Text>}
        paddingX={0}
        paddingY={0}
      />
      <TextInput
        testID="team-invite-email-input"
        type="email"
        value={email}
        onChange={onEmailChange}
        placeholder={formatMessage(messages.emailPlaceholder)}
        accessibilityLabel={formatMessage(messages.emailLabel)}
        helperText={hasError ? errorMessage : formatMessage(messages.emailHelperText)}
        helperTextErrorIconAccessibilityLabel={formatMessage(messages.emailErrorIconHelperText)}
        variant={hasError ? 'negative' : undefined}
        height={48}
      />
    </VStack>
  );
}
